import { takeLatest, put } from 'redux-saga/effects';
import { delay } from 'redux-saga';

import { reset, onClickNotif } from './actions';
import {
  NOTIFICATION_SUCCESS,
  NOTIFICATION_ERROR,
  NOTIFICATION_WARNING,
} from './types';

export function* resetNotification() {
  yield put(onClickNotif(false));
  yield delay(4000, true);
  yield put(reset());
}

export default function* saga() {
  yield takeLatest(NOTIFICATION_SUCCESS, resetNotification);
  yield takeLatest(NOTIFICATION_ERROR, resetNotification);
  yield takeLatest(NOTIFICATION_WARNING, resetNotification);
}
